import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Выездной туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Путешествия лиц, постоянно проживающих в одной стране, в другую страну с туристскими целями без
                        занятия оплачиваемой деятельностью в посещаемой стране.</p>
                </div>
            </div>
        </>
    );
}